import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { CommunityDevelopmentNoteDto, FormDto } from "../../../services/dto";
import * as yup from "yup";
import React from "react";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface CommunityDevelopmentNotesFormProps {
    data?: CommunityDevelopmentNoteDto | undefined;
    show: boolean;
    onHide: () => void;
    onSave: (values: CommunityDevelopmentNoteDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
    notes: yup.string().required("Notes is required"),

});

export const CommunityDevelopmentNotesForm = (props: CommunityDevelopmentNotesFormProps) => {
    let notes: CommunityDevelopmentNoteDto | undefined = props.data;
    let title: string = notes && notes.id !== Constants.emptyGuid ? "Edit Notes" : "Add Notes";
    const onSubmit = (data: CommunityDevelopmentNoteDto) => {
        data.communityDevelopmentId = notes?.communityDevelopmentId ?? Constants.emptyGuid;
        data.submittedBy = data.submittedBy ?? Constants.emptyString;
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };
    const isNew: boolean = !notes?.id || notes?.id === Constants.emptyGuid;
    const isLoading: boolean = props.show && !isNew && !notes;

    return (
        <Drawer.Form
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={props.onHide}
            title={title}
            initialValues={notes ?? {}}
            validationSchema={validationSchema}
            on_Submit={onSubmit}
        >

            <Form.TextArea
                name="notes"
                rows={3}
                label="Notes"
                isLoading={isLoading}
            />

        </Drawer.Form>
    );
}

